import { LoadingSpinner } from '@zonofi/zono-money-design-system';
import React, { useEffect, useState } from 'react';
import './dialer-redirect-screen.scss';
import { useSearchParams } from 'react-router-dom';

type RedirectStatus = 'loading' | 'redirecting' | 'error';

export const DialerRedirectScreen: React.FC = () => {
  const [status, setStatus] = useState<RedirectStatus>('loading');
  const [phoneNo, setPhoneNo] = useState<string | null>(null);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [params] = useSearchParams();

  useEffect(() => {
    const phone = params.get('phone');

    if (!phone) {
      setStatus('error');
      setErrorMsg('No phone number found in the URL.');
      return;
    }

    // Sanitize: strip non-digit/+/- characters for the tel: URI
    const sanitized = phone.replace(/[^\d+\-() ]/g, '');
    setPhoneNo(sanitized);
    setStatus('redirecting');

    window.location.href = `tel:${sanitized}`;
  }, []);

  return (
    <div className="dialer-redirect">
      <p className="dialer-redirect__number">{phoneNo}</p>
      <p className="dialer-redirect__label">Opening dialer…</p>
      <div className="dialer-redirect__bar">
        <div className="dialer-redirect__bar-fill" />
      </div>
    </div>
  );
};
